/**
 * Registration age requirements
 */

const AgeRanges = {
  GROUP: {
    REQUIRED: 16,
  },
  ONLINE: {
    REQUIRED: 18,
  },
  GROUP_AND_ONLINE: {
    MAX: 122,
  },
};

export default AgeRanges;

// Your birthday plus this value = earliest journey start date
export const journeyStartAge = 16;
